module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-modular-check kp-modular-check-without-icon"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.step.description_visibility
    },
    on: {
      "change": function($event) {
        return _vm.stepChangeDescriptionVisibity({
          event: $event,
          id: _vm.step.id
        })
      }
    }
  }), _c('span')])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-81ef8228!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/step/config/DescriptionCheckbox.vue
 ** module id = 881
 ** module chunks = 1
 **/